<template>
  <FlotoForm ref="form" class="mx-4" @submit="handleApply">
    <MRow
      class="bg-gradient rounded py-1 items-center border border-solid border-neutral-light"
    >
      <MCol>
        <FlotoFormItem
          :label="`${$t('from')}`"
          hide-message
          :rules="{
            required: true,
            // eslint-disable-next-line
            max_date: toDate,
          }"
        >
          <FlotoDatePicker
            v-model="fromDate"
            :max-date="toDate"
            :allow-clear="false"
          />
        </FlotoFormItem>
      </MCol>
      <MCol>
        <FlotoFormItem
          hide-message
          :label="`${$t('to')}`"
          :rules="{
            required: true,
            // eslint-disable-next-line
            min_date: fromDate,
          }"
        >
          <FlotoDatePicker
            v-model="toDate"
            :min-date="fromDate"
            :allow-clear="false"
          />
        </FlotoFormItem>
      </MCol>
      <MCol v-if="allowUserFilter" :size="3">
        <FlotoFormItem hide-message :label="$tc('user')">
          <FlotoTechnicianPicker v-model="createdById" as-input />
        </FlotoFormItem>
      </MCol>

      <MCol auto-size class="mt-2">
        <MButton @click="submitForm">{{ $t('apply') }}</MButton>
      </MCol>
    </MRow>
    <template v-slot:submit>
      <span />
    </template>
  </FlotoForm>
</template>

<script>
export default {
  name: 'DownloadsFilter',
  props: {
    value: {
      type: Object,
      default: () => ({
        fromDate: 0,
        toDate: 0,
        createdById: 0,
      }),
    },
    allowUserFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fromDate: this.value.fromDate,
      toDate: this.value.toDate,
      createdById: this.value.createdById,
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.submit()
    },
    handleApply() {
      this.$emit('change', {
        fromDate: this.fromDate,
        toDate: this.toDate,
        createdById: this.createdById,
      })
    },
  },
}
</script>
